import { SnackbarKey } from "notistack";
import { SnackbarOptions } from "contexts/SnackbarContext";

type ToastHandler = (message: string, options?: SnackbarOptions) => SnackbarKey | undefined;

let toastHandler: ToastHandler | null = null;

export const setToastHandler = (fn: ToastHandler) => {
  toastHandler = fn;
};

export type SnackbarMethodOptions = Omit<SnackbarOptions, "variant">;

const handleShowSnackbar = (message: string, options: SnackbarOptions) => {
  if (!toastHandler) {
    console.warn("Toast handler not initialized");
    return;
  }

  return toastHandler(message, options);
};

const snackbar = {
  success: (message: string, options?: SnackbarMethodOptions) =>
    handleShowSnackbar(message, {
      variant: "success",
      ...options,
    }),
  warning: (message: string, options?: SnackbarMethodOptions) =>
    handleShowSnackbar(message, {
      variant: "warning",
      ...options,
    }),
  info: (message: string, options?: SnackbarMethodOptions) =>
    handleShowSnackbar(message, {
      variant: "info",
      ...options,
    }),
  error: (message: string, options?: SnackbarMethodOptions) =>
    handleShowSnackbar(message, {
      variant: "error",
      ...options,
    }),
  default: (message: string, options?: SnackbarMethodOptions) =>
    handleShowSnackbar(message, {
      variant: "default",
      ...options,
    }),
};

export default snackbar;
